import notifier from '@/notifier'
import api from '@/api'
import { isObject, transform } from 'lodash'

const omit = function (obj) {
  function omitFromObject (obj) {
    return transform(obj, function (result, value, key) {
      if (value === '' || value === undefined || value === null) {
        return
      }

      result[key] = isObject(value) ? omitFromObject(value) : value
    })
  }

  return omitFromObject(obj)
}

export default {
  namespaced: true,
  state: {
    sending: false,
    items: [],
    fetching: false
  },
  actions: {
    async add ({ state, commit, getters }, products) {
      commit('fetching')

      commit('setFetchData', products)
    },
    async send ({ state, commit, getters }, module) {
      for (var i in state.items) {
        let variation = omit(state.items[i])

        if (variation.original.variation.status === 'sent' || variation.original.variation.status === 'cannotSend') {
          continue
        }

        if (this.getters['errors/getErrorsByProductId'](variation.productId)) {
          commit('setStatusVariationToFix', variation)
          continue
        }

        if (this.getters['errors/getErrorsBySku'](variation.sku)) {
          commit('setStatusVariationToFix', variation)
          continue
        }

        try {
          commit('setStatusVariationToSending', variation)

          if (module.identifier === 'amazon') {
            variation.sizes = []
            variation.colors = []
          }

          await api.saveProduct(module.type, module.identifier, variation)

          commit('setStatusVariationToSent', variation)
        } catch (error) {
          if (error.response.status === 422) {
            commit('setStatusVariationToError', variation)
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') === -1) {
            notifier.error(error.response.data.message, 'Falha')
            commit('setStatusVariationToError', variation)
            return false
          } else if (error.response.status === 400 && error.response.data.message.indexOf('Validation failed') !== -1) {
            commit('addError', {
              variation: variation,
              errors: error.response.data.data
            })
            commit('setStatusVariationToFix', variation)
          } else if (error.response.status === 409) {
            commit('addError', {
              variation: variation,
              errors: error.response.data.data
            })
            commit('setStatusVariationToFix', variation)
          } else {
            commit('setStatusVariationToError', variation)
          }
        }

        variation.original.product.variations = [...variation.original.product.variations]

        commit('updateProductStatus', variation)
      }

      let countToFix = 0
      for (var j in state.items) {
        const variation = state.items[j]

        if (
          variation.original.product.variations.filter(variation => variation.selected && variation.status === 'to-fix').length ||
          variation.original.product.status === 'to-fix'
        ) {
          countToFix++
        }
      }

      if (countToFix === 0) {
        notifier.success('Alteração em lote finalizada!', 'Finalizado')

        return true
      } else {
        notifier.error('Falha na alteração em lote!', 'Falha')

        return false
      }
    },
    async clear ({ state, commit, getters }) {
      const items = []
      commit('setFetchData', {
        items
      })
    }
  },
  getters: {
    getAllVariations: state => () => state.items
  },
  mutations: {
    setFetchData (state, items) {
      state.items = null
      state.items = items
      state.fetching = false
    },
    setStatusVariationToSending (state, item) {
      for (var x in state.items) {
        let i = state.items[x]

        if (i.original.variation.sku === item.sku) {
          i.original.product.status = 'sending'
          i.original.variation.status = 'sending'
        }
      }
    },
    setStatusVariationToSent (state, item) {
      for (var x in state.items) {
        let i = state.items[x]

        if (i.original.variation.sku === item.sku) {
          i.original.variation.status = 'sent'
        }
      }
    },
    setStatusVariationToFix (state, item) {
      for (var x in state.items) {
        let i = state.items[x]

        if (i.original.product.productId === item.original.product.productId) {
          i.original.product.status = 'to-fix'
        }

        if (i.original.variation.sku === item.sku) {
          i.original.variation.status = 'to-fix'
        }
      }
    },
    setStatusVariationToError (state, item) {
      for (var x in state.items) {
        let i = state.items[x]

        if (i.original.variation.sku === item.sku) {
          i.original.product.status = 'error'
          i.original.variation.status = 'error'
        }
      }
    },
    updateProductStatus (state, item) {
      for (var x in state.items) {
        let i = state.items[x]

        if (i.original.variation.sku === item.sku) {
          const sentVariations = i.original.product.variations
            .filter(variation => variation.selected && variation.status === 'sending')
            .length

          const variationErrors = i.original.product.variations
            .filter(variation => variation.selected && variation.status === 'error')
            .length

          const variationToFix = i.original.product.variations
            .filter(variation => variation.selected && variation.status === 'to-fix')
            .length

          if (sentVariations === 0 && variationToFix > 0) {
            i.original.product.status = 'to-fix'
          } else if (sentVariations === 0 && variationErrors > 0) {
            i.original.product.status = 'error'
          } else {
            i.original.product.status = 'sent'
          }
        }
      }
    },
    addError (state, { variation, errors }) {
      for (var i in errors) {
        const error = errors[i]
        this._actions['errors/addError'][0]({
          productId: variation.original.product.productId,
          sku: variation.original.variation.sku,
          property: error.property,
          error: {
            message: error.constraint,
            value: error[error.constraint]
          }
        })
      }
    },
    fetching (state) {
      state.fetching = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/panel/sendProducts.js